import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { firstValueFrom, Observable } from 'rxjs';
import { Apollo } from 'apollo-angular';
import { getPerspectiveById, getPerspectives } from './querys';

export class Perspectivas{
  public id?: number;
  public name?: string;
  public description?: string;
  public planningId?: number;
}

@Injectable({
  providedIn: 'root'
})
export class PerspectivaService {
  private apiURL = environment.apiURL_institucion;
  private headers = new HttpHeaders().append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'));

  constructor(
    private http: HttpClient,
    private cookies: CookieService,
        private apollo: Apollo,    
  ) {}

  public getPerspectivas(): Observable<any>{
    const apiURL = `${this.apiURL}perspectivas`
    return this.http.get(`${apiURL}`, {headers: this.headers});
  }
  async getPerspectivasGQL(){
    const { data } = await firstValueFrom(
      this.apollo.use(environment.apiURL_gestion).watchQuery<any>({
        query: getPerspectives,
        context: {headers: this.headers},
      }).valueChanges
    );
    return data.perspectives;
  }
  async getPerspectivasByIdGQL(idPlanning: number){
    const { data } = await firstValueFrom(
      this.apollo.use(environment.apiURL_gestion).watchQuery<any>({
        query: getPerspectiveById,
        context: {headers: this.headers},
        fetchPolicy: 'no-cache',
        variables: {
          "args": {
            "filter": {
              "conditions": [
                {
                  "field": "planningId",
                  "operator": "EQUAL",
                  "value": idPlanning
                }
              ]
            }
          }
        }
      }).valueChanges
    );
    return data.searchPerspectives.data;
  }
  public postPerspectivas(perspectiv: any): Observable<any>{
    var perspe: Perspectivas;
    if(perspectiv.descripcion !== ''){
      perspe = {
        name: perspectiv.nombre,
        description: perspectiv.descripcion ,
        planningId: Number(perspectiv.planningId),
      }
    }else{
      perspe = {
        name: perspectiv.nombre,
        planningId: Number(perspectiv.planningId),
      }
    }
    const body = JSON.stringify(perspe);
    const apiURL = `${this.apiURL}perspectivas`;
    return this.http.post(`${apiURL}`, body, {headers: this.headers});
  }
  public patchPerspectivas(perspectiv: any): Observable<any>{
    var perspe: Perspectivas;
    if(perspectiv.descripcion !== ''){
      perspe = {
        name: perspectiv.nombre,
        description: perspectiv.descripcion ,
        planningId: Number(perspectiv.planningId),
      }
    }else{
      perspe = {
        name: perspectiv.nombre,
        planningId: Number(perspectiv.planningId),
      }
    }
    const body = JSON.stringify(perspe);
    const apiURL = `${this.apiURL}perspectivas/${perspectiv.id}`;
    return this.http.patch(`${apiURL}`, body, {headers: this.headers});
  }

  public deletePer(per): Observable<any>{
    const apiURL = `${this.apiURL}perspectivas/${per.id}`;
    return this.http.delete(`${apiURL}`, {headers: this.headers});
  }
}
